import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, uplodateLoading } from '../../../redux/features/common/commonSlice';
import { Box, Pagination, Button } from '@mui/material';
import { NavBarTop } from '../../structure/NavBarTop';
import NavBar from '../../structure/NavBar';
import { InputGroup, Form } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';

const ShoppingManager = () => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state?.userData);
  const [datalist, setDatalist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [startDate, setStartDate] = useState(dayjs('2024-01-01'));
  const [endDate, setEndDate] = useState(dayjs('2025-12-31'));
  const [searchText, setSearchText] = useState('');
  const [statusDropdownText, setStatusDropdownText] = useState('Select Status');

    useEffect(() => {
        dispatch(updateTopHeader("Shopping Manager"));
      }, []);

  useEffect(() => {
    // On first load or page change, use current filter state
    getShoppingList({
      searchText,
      startDate,
      endDate
    });
    // eslint-disable-next-line
  }, [page]);

  const getShoppingList = async (customFilters = {}) => {
    try {
      dispatch(uplodateLoading(true));
      const postJson = {
        page: page - 1,
        limit: 10,
        searchText: customFilters.searchText !== undefined ? customFilters.searchText : searchText,
        shortingField: 'createdAt',
        asc: true,
        active: true,
        startDate: (customFilters.startDate || startDate).format ? (customFilters.startDate || startDate).format('YYYY-MM-DD') : (customFilters.startDate || startDate),
        endDate: (customFilters.endDate || endDate).format ? (customFilters.endDate || endDate).format('YYYY-MM-DD') : (customFilters.endDate || endDate)
      };
      // Use API URL from constants
      const url = urls.shoppingDataList;
      let res = await ApiCaller.post(postJson, url, userData?.access_token);
      let response;
      try {
        response = await res.response.json();
      } catch (jsonErr) {
        dispatch(uplodateLoading(false));
        alert('Invalid or empty response from server.');
        return;
      }
      if (!res.response.ok) {
        dispatch(uplodateLoading(false));
        alert(response?.message || 'Server error');
        return;
      }
      const apiData = response.data;
      if (
        response.status === 'OK' ||
        response.status === 200 ||
        response.status === '200' ||
        response.httpStatus === 'OK'
      ) {
        dispatch(uplodateLoading(false));
        setDatalist(Array.isArray(apiData.items) ? apiData.items : []);
        setPagerecord({
          totalItems: apiData.totalItems || (apiData.items?.length || 0),
          totalPages: apiData.totalPages || 1,
          pageNumber: typeof apiData.pageNumber === 'number' ? apiData.pageNumber + 1 : page,
          pageSize: apiData.pageSize || 10
        });
      } else {
        dispatch(uplodateLoading(false));
        alert(response.message || 'Something went wrong');
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      alert(error.message || 'Server Error');
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleFilterClick = () => {
    setPage(1);
    // Use a callback to ensure getShoppingList uses the latest startDate/endDate
    setTimeout(() => {
      getShoppingList({
        searchText,
        startDate,
        endDate
      });
    }, 0);
  };

  const handleResetFilter = () => {
    const defaultStartDate = dayjs('2024-01-01');
    const defaultEndDate = dayjs('2025-12-31');
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    setSearchText('');
    setStatusDropdownText('Select Status');
    setPage(1);
    setTimeout(() => {
      getShoppingList({
        searchText: '',
        startDate: defaultStartDate,
        endDate: defaultEndDate
      });
    }, 0);
  };

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        <div className='container-fluid mt--7'>
          <div className='row'>
            <div className='col text-left'>
              <div className='card shadow mb-4'>
                <div className='card-header border-0'>
                  <h3 className='mb-0'>Shopping Manager</h3>
                </div>
                <div className='card-header border-0'>
                  <div className='row align-items-center text-left'>
                    <div className='col-md-3'>
                      <InputGroup className='mb-2' style={{ borderRadius: '10px' }}>
                        <Form.Control
                          placeholder='Search by email/store name'
                          value={searchText}
                          onChange={e => setSearchText(e.target.value)}
                          aria-label='Search by email/store name'
                        />
                      </InputGroup>
                    </div>
                    <div className='col-md-6 mb-3' style={{ marginLeft: '40px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                          <DatePicker
                            className='custom-date'
                            label='From Date'
                            value={startDate}
                            onChange={newValue => setStartDate(newValue)}
                            maxDate={endDate}
                          />
                          <DatePicker
                            label='To Date'
                            value={endDate}
                            onChange={newValue => setEndDate(newValue)}
                            minDate={startDate}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div className='col-md-3 mb-2'>
                      <Button
                        variant='contained'
                        className='custom-filter-btn'
                        onClick={handleFilterClick}
                      >
                        Filter
                      </Button>
                      <Button
                        variant='contained'
                        className='ml-2 custom-filter-btn'
                        onClick={handleResetFilter}
                      >
                        Reset
                      </Button>
                    </div>
                  </div>
                </div>
                <div className='card-body'>
                  <div className='table-responsive'>
                    <table className='table align-items-center table-flush'>
                      <thead className='thead-light'>
                        <tr>
                          <th>#</th>
                          <th>Email</th>
                          <th>Store Name</th>
                          <th>Order Amount</th>
                          <th>Cashback</th>
                          <th>Currency</th>
                          <th>Status</th>
                          <th>Type</th>
                          <th>Confirm Duration</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(datalist) && datalist.length > 0 ? datalist.map((item, idx) => (
                          <tr key={item.uuid || idx}>
                            <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                            <td>{item.email}</td>
                            <td>{item.storeName}</td>
                            <td>{item.orderAmount !== null ? item.orderAmount : '-'}</td>
                            <td>{item.cashback}</td>
                            <td>{item.currency}</td>
                            <td>{item.status || '-'}</td>
                            <td>{item.type}</td>
                            <td>{item.confirmDuration}</td>
                            <td>{item.createdAt ? new Date(item.createdAt).toLocaleString() : '-'}</td>
                          </tr>
                        )) : (
                          <tr><td colSpan={11} className='text-center'>No Data Found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='card-footer py-4'>
                  <Box display='flex' justifyContent='right' alignItems='center'>
                    <span>Total record: {pagerecord?.totalItems}</span>
                    <Pagination
                      className='custom-pagination-class'
                      count={pagerecord?.totalPages}
                      page={page}
                      onChange={handleChange}
                      color='secondary'
                    />
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShoppingManager;
